<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">
      <fa-icon [icon]="faUserGroup" class="mr-1"></fa-icon>
      ETA Date Updation
    </h1>
    <app-navpath class="hidden md:block"></app-navpath>
  </div>

  <div class="content-container">
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">
        ETA Date Updation
      </h2>

      <app-data-form
        [dataFields]="searchBooking"
        [dataName]="'searchBooking'"
        (updateFields_child)="updateFields($event)"
      ></app-data-form>
    </section>

    <div class="mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" [disabled]="isUpdating" (click)="updateETA()">
        <fa-icon [icon]="faPencil" class="mr-1"></fa-icon>
        Update
      </button>

      <button class="shorter-btn clear-btn" [disabled]="isUpdating" (click)="clearForm()">
        <fa-icon [icon]="faEraser" class="mr-1"></fa-icon>
        Clear
      </button>
    </div>
  </div>
</section>
